import { useCardActivate } from "@usher/pe-client-front-end-lib"
import { Modal } from "@/components/Modal"
import { useState } from "react"
import { Button } from "@/components/Button"
import { Alert } from "@/components/Alert"
import { FormattedMessage } from "react-intl"

export const Activation = ({ card_id }: { card_id: number }) => {
  const [show, setShow] = useState(false)
  const { activateCard } = useCardActivate({ card_id, onSuccess: () => setShow(false) })
  return (
    <>
      <Modal title={<FormattedMessage id="act-2" />} show={show} onClose={() => setShow(false)}>
        <>
          <Alert className="mt-3 mb-4">
            <span>
              <FormattedMessage id="act-1" />
            </span>
          </Alert>
          <Button onClick={activateCard}>
            <FormattedMessage id="act-2" />
          </Button>
        </>
      </Modal>
      <Alert className="my-6">
        <div className="flex flex-col w-full md:flex-row items-start gap-2.5">
          <span>
            <FormattedMessage id="act-3" />
          </span>
          <Button
            onClick={() => {
              setShow(true)
            }}
            size="sm"
            className="self-end md:self-auto mt-[-2px]"
          >
            <FormattedMessage id="act-2" />
          </Button>
        </div>
      </Alert>
    </>
  )
}
